import React from 'react';
import ReactMarkdown from 'react-markdown';

const TextViewer = ({ content = '' }) => {
  return <ReactMarkdown>{content}</ReactMarkdown>;
};

export default TextViewer;
